export const RAPID_DELIVERY_ALGOLIA_TAG = 'rapidDelivery'



